import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "collapsed-table" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = {
  ref: "title",
  class: "title"
}
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "head" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_MdTable = _resolveComponent("MdTable")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title", {}, undefined, true)
        ], 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Tooltip, { text: "Copy table" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                hoverable: "",
                stroke: "var(--gray-700)",
                class: "pointer",
                icon: "copy",
                "stroke-width": "1",
                size: "1.6rem",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$throttle_1000($options.copyText)))
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Tooltip, { text: "Download table" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                hoverable: "",
                stroke: "var(--gray-700)",
                class: "pointer",
                icon: "download",
                "stroke-width": "1",
                size: "1.6rem",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$throttle_1000($options.downloadCSV)))
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_Tooltip, { text: "Expand table" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                hoverable: "",
                stroke: "var(--gray-700)",
                class: "pointer",
                icon: "expand-06",
                "stroke-width": "1",
                size: "1.6rem",
                onClick: $options.open
              }, null, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _createVNode(_component_MdTable, {
        ref: "table",
        class: "pointer",
        onClick: $options.open
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    (_ctx.mount_modal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          ref: "modal",
          max_width: "90%",
          min_width: _ctx.$responsive.desktop ? undefined : '30rem',
          "dialog-class": "md-expanded",
          onClickOutside: $options.close,
          onAfterEnter: $options.afterEnter,
          onAfterLeave: _cache[4] || (_cache[4] = $event => (_ctx.mount_modal = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "title", {}, undefined, true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Tooltip, { text: "Copy table" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      hoverable: "",
                      stroke: "var(--gray-700)",
                      class: "pointer",
                      icon: "copy",
                      "stroke-width": "1",
                      size: "1.6rem",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.$throttle_1000($options.copyText)))
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_Tooltip, { text: "Download table" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      hoverable: "",
                      stroke: "var(--gray-700)",
                      class: "pointer",
                      icon: "download",
                      "stroke-width": "1",
                      size: "1.6rem",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.$throttle_1000($options.downloadCSV)))
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_Tooltip, { text: "Collapse table" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      hoverable: "",
                      stroke: "var(--gray-700)",
                      class: "pointer",
                      icon: "collapse-06",
                      "stroke-width": "1",
                      size: "1.6rem",
                      onClick: $options.close
                    }, null, 8 /* PROPS */, ["onClick"])
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _createVNode(_component_MdTable, {
              ref: "modal_table",
              class: "modal-table"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _: 3 /* FORWARDED */
            }, 512 /* NEED_PATCH */)
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["min_width", "onClickOutside", "onAfterEnter"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}